import * as React from 'react';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import MuiDrawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import {ExpandLess, ExpandMore} from "@mui/icons-material";
import {Collapse, Typography} from "@mui/material";
import {useMemo, useState} from "react";
import PatientMerges from "./patient_merges";
import HL7Dashboard from "./hl7/hl7_dashboard";
import FHIRDashboard from "./fhirsendadmin";
import AgyleConfiguration from './agyle_configuration';
import AdminDashboard from "./admin_dashboard";
import {AgyleNamedIcon} from "../../components/icons/agyle";
import makeStyles from "@mui/styles/makeStyles";
import AnnouncementAdmin from "./announcement_admin";
import Dictionaries from "./dictionaries";
import {useHistory, useLocation} from "react-router-dom";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import {hasOneOfPermission, Permissions} from "../../store/reducers/user";
import {useDispatch} from "react-redux";
import PinManagement from './pin_management';
import MapIcon from '@mui/icons-material/Map';
import Ward_admin from './ward_admin';
import TestPage from './testSection/testPage';
import config from '../../app/config';
import SettingsIcon from '@mui/icons-material/Settings';
import SvgIcon from '@mui/material/SvgIcon';
import ReportsDashboard from './reports/reports_dashboard';
import AssessmentIcon from '@mui/icons-material/Assessment';
import LocalFireDepartmentIcon from '@mui/icons-material/LocalFireDepartment';
import AttendancesManagment from './attendnaces/attendances';
import {useTranslation} from 'react-i18next';
import PatientsDocList from './patients/patientsDocList';
import PersonIcon from '@mui/icons-material/Person';
import AgyleMenuIcon from '../../components/header/agyleMenu/agyleMenuIcon';
const drawerWidth = 350;

const useStyles = makeStyles((theme) => ({
    menuText: {
        padding: "15px 0px 0px 15px",
        fontSize: "14px",
        // color: "#A8A8A8",
        color: theme.palette.primary.secondary,
    }
}));
export const StyledTabs = styled(Tabs)({
    "&.MuiTabs-indicator": {
        backgroundColor:"#448FFF"
    }
})

export const StyledTab = styled(Tab)({
    "&.Mui-selected": {
        color:"#448FFF"
    }
})

const openedMixin = (theme) => ({
 //   backgroundColor: "#F7F7F7",
    width: drawerWidth,
    transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
    }),
    overflowX: 'hidden',
});

const closedMixin = (theme) => ({
  //  backgroundColor: "#F7F7F7",
    transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: 'hidden',
    width: `calc(${theme.spacing(7)} + 1px)`,
    [theme.breakpoints.up('sm')]: {
        width: `calc(${theme.spacing(8)} + 1px)`,
    },
});

const DrawerHeader = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
}));

const Drawer = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== 'open' })(
    ({ theme, open }) => ({
        width: drawerWidth,
        flexShrink: 0,
        whiteSpace: 'nowrap',
        boxSizing: 'border-box',
        ...(open && {
            ...openedMixin(theme),
            '& .MuiDrawer-paper': openedMixin(theme),
        }),
        ...(!open && {
            ...closedMixin(theme),
            '& .MuiDrawer-paper': closedMixin(theme),
        }),
    }),
);


export default function Admin() {
    const classes = useStyles();
    const { t, i18n } = useTranslation();
    const [open, setOpen] = React.useState(false);
    const [expandSubMenu, setExpandSubMenu] = useState({});
    const [selectedPatentItemLabel, setSelectedParentItemLabel] = useState("DASH");
    const location = useLocation();
    const history = useHistory();
    const dispatch = useDispatch();

    React.useEffect(() => {
        let params = new URLSearchParams(location.search);
        let section = params.get("section");

        if(section){
            getMenuItem().every( (item) => {
                if(item.hasOwnProperty("name") && item.name === section ){
                    openComponent(item);
                    return false;
                } else {
                    if(item.hasOwnProperty("subMenu")){
                        item.subMenu.every((subItem) => {
                            if(subItem.hasOwnProperty("name") && subItem.name === section ){
                                openComponent(subItem, item.label);
                                return false;
                            }
                            return true;
                        })
                    }
                }
                return true;
            })
        }
    }, [location.search])

    const openComponent = (item, parentLabel) => {
        setSelectedItem(item);
        setSelectedParentItemLabel(parentLabel? parentLabel: item.label);
        window._scrollBarRef._container.scrollTop = 0;
    }

    const menuItems = [
        {
            label: "Patient Merges",
            name: "patientMerges",
            visible: process.env.BUILD_MODULE === 'agyle' && dispatch(hasOneOfPermission([Permissions.CAN_ACCESS_MERGES_PAGE])),
            icon: <AgyleNamedIcon name={"patientMerges"}/>,
            component: PatientMerges,
        },
        {
            label: "PIN Management",
            name: "pinManagement",
            visible: process.env.BUILD_MODULE === 'agyle' && dispatch(hasOneOfPermission([Permissions.CAN_MANAGE_PINS, Permissions.CAN_ACCESS_PIN_ADMIN])),
            icon: <AgyleNamedIcon name={"padlock"}/>,
            component: PinManagement,
        },
        {
            label: "HL-7 Dashboard",
            name: "hl7dashboard",
            visible: dispatch(hasOneOfPermission([Permissions.CAN_ACCESS_HL7DASHBOARD])),
            icon: <AgyleNamedIcon name={"hl7dashboard"}/>,
            component:  HL7Dashboard,
        },
        {
            label: "Smart Filters",
            name: "smartFilters",
            visible: process.env.BUILD_MODULE === 'main' && dispatch(hasOneOfPermission([Permissions.CAN_VIEW_PATIENT_RECORD])),
            icon: <PersonIcon/>,
            component: PatientsDocList,
        },
        {
            label: "Reports",
            name: "reports",
            visible: dispatch(hasOneOfPermission([Permissions.CAN_ACCESS_REPORTS, Permissions.CAN_ACCESS_STATISTICS])),
            icon: <AssessmentIcon/>,
            component:  ReportsDashboard,
        },
        {
            label: "FHIR Dashboard",
            name: "fhirdashboard",
            visible: process.env.BUILD_MODULE === 'agyle' && dispatch(hasOneOfPermission([Permissions.CAN_ACCESS_FHIR_DASHBOARD])),
            icon: <LocalFireDepartmentIcon/>,
            component:  FHIRDashboard,
        },
        // {
        //     label: "Documents",
        //     icon: <AgyleNamedIcon name={"documents"}/>,
        //     component:  DocumentsAdmin,
        //     subMenu: [
        //         {
        //             label: "Documents",
        //             name: "documents",
        //             component:  DocumentsAdmin,
        //         },
        //         {
        //             label: "Documents Statistic",
        //             name: "documentsStat",
        //             component:  DocumentsStatistic,
        //         }
        //     ]
        // },
        {
            label: "Dictionaries",
            icon: <AgyleNamedIcon name={"dictionaries"}/>,
            visible: process.env.BUILD_MODULE === 'agyle' && dispatch(hasOneOfPermission([Permissions.CAN_ACCESS_DICTIONARIES])),
            component: Dictionaries,
            subMenu: [
                {
                    label: "Dictionaries",
                    name: "dictionaries",
                    component: Dictionaries,
                    props: {selectedTab: 0}
                },
                {
                    label: "Dictionaries audit",
                    name: "dictionariesAudit",
                    component: Dictionaries,
                    props: {selectedTab: 1}
                },
                {
                    label: "NHS Upsert data",
                    name: "nhsUpserData",
                    component: Dictionaries,
                    props: {selectedTab: 2}
                }
            ]
        },
        {
            label: "Announcements",
            name: "announcements",
            visible: process.env.BUILD_MODULE === 'agyle' && dispatch(hasOneOfPermission([Permissions.CAN_ADD_ANNOUNCEMENT])),
            icon: <AgyleNamedIcon name={"announcements"}/>,
            component:  AnnouncementAdmin,
        },
        {
            label: "Attendances",
            name: "attendances",
            visible: process.env.BUILD_MODULE === 'agyle' && dispatch(hasOneOfPermission([Permissions.CAN_ACCESS_ADMIN_PAGE])),
            icon: <AgyleNamedIcon name={"cancelAttendances"}/>,
            component:  AttendancesManagment,
        },
        {
            label: "System Configuration",
            name: "config",
            visible: process.env.BUILD_MODULE === 'agyle' && dispatch(hasOneOfPermission([Permissions.AGYLE_CAN_CONFIG_SYSTEM])),
            icon: <SettingsIcon />,
            component: AgyleConfiguration,
        }
        // {
        //     label: "Cancelled Attendances",
        //     icon: <AgyleNamedIcon name={"cancelAttendances"}/>,
        //     component:  HL7Dashboard,
        // },
        // {
        //     label: "Pin Administration",
        //     icon: <AgyleNamedIcon name={"pinAdministration"}/>,
        //     component:  HL7Dashboard,
        // },
        // {
        //     label: "Deleted Investigations",
        //     icon: <AgyleNamedIcon name={"deletedInvestigations"}/>,
        //     component:  HL7Dashboard,
        // },
        // {
        //     label: "Documents Retention",
        //     icon: <AgyleNamedIcon name={"documentsRetention"}/>,
        //     component:  HL7Dashboard,
        //     subMenu: [
        //         {
        //             label: "Approaching Retention",
        //             component: ApproachingRetention,
        //         },
        //         {
        //             label: "During Deletion",
        //             component: HL7Dashboard,
        //         },
        //         {
        //             label: "Audit",
        //             component: HL7Dashboard,
        //         }
        //     ]
        // },
        // {
        //     label: "User Audit",
        //     icon: <AgyleNamedIcon name={"userAudit"}/>,
        //     component:  HL7Dashboard,
        // },
    ]

    if (config?.modules?.testPage?.enabled) {
        menuItems.push({
            label: "Test page",
            name: "testPage",
            visible: process.env.BUILD_MODULE === 'agyle',
            icon: <AgyleNamedIcon name={"help"}/>,
            component:  TestPage,
        })
    }

    if (config?.modules?.wardCreator?.wardManagement) {
        menuItems.push({
            label: "Ward Management",
            name: "wardSettings",
            visible: process.env.BUILD_MODULE === 'agyle' && dispatch(hasOneOfPermission([Permissions.AGYLE_CAN_MANAGE_ESCALATION])),
            icon: <MapIcon />,
            component:  Ward_admin,
        })
    }

    const getMenuItem = () => {
        return process.env.BUILD_MODULE === 'agyle' && dispatch(hasOneOfPermission([Permissions.CAN_ACCESS_ADMIN_PAGE]))?
                    menuItems: menuItems.filter(item => item.visible)
    }

    const DashboardItem = {
        label: "DASH",
        icon: <AgyleNamedIcon name={"adminDashboard"}/>,
        component: AdminDashboard,
        props: {
            menu: getMenuItem,
            openTab: openComponent
        },
        minContent: true
    }

    const [selectedItem, setSelectedItem] = useState(DashboardItem);

    const handleDrawerClick = () => {
        setOpen(!open);
    };

    const handleMainPageClick = () => {
        if(process.env.BUILD_MODULE === "main") {
            history.push("/");
        } else {
            history.goBack()
        }
    };

    const handleSubMenuClick = (e, index) => {
        setExpandSubMenu((prev) =>
            ({
                ...prev,
                [index]: !prev[index],
            })
        );
        e.stopPropagation();
    }


    const renderComponent = useMemo(()=>{
        if(selectedItem)
            return (
                React.createElement(selectedItem.component, {
                    ...selectedItem.props,
                    name: selectedItem.label
            }))
    }, [selectedItem]);

    return (
        <Box sx={{ display: 'flex', justifyContent: "center" }}>
            <Drawer variant="permanent" open={open}>
                <DrawerHeader>
                    <div style={{ display: "flex",  flexDirection: "column", justifyContent: "center"}}>
                        {process.env.BUILD_MODULE === "main" &&
                            <IconButton onClick={handleMainPageClick} classes={{ root: classes.eyonixIcon }} size="large">
                                <SvgIcon className="big_svg_icon" color="primary">
                                    <path d="M21.493,2l-9.558,0.001C6.444,2.04,2,6.505,2,12.008c0,0.013,0,7.37,0,9.448C2.007,21.758,2.23,22,2.504,22h9.625
                        c5.393-0.065,9.752-4.392,9.871-9.77V2.557C22,2.248,21.772,2,21.493,2z M18.66,18.298c-0.004,0.201-0.151,0.363-0.335,0.363
                        h-6.411c-3.592-0.042-6.496-2.926-6.574-6.509V5.708c0-0.205,0.151-0.371,0.336-0.371h6.366c3.66,0.027,6.618,3.003,6.618,6.667
                        C18.66,12.012,18.66,16.915,18.66,18.298z"/>
                                    <path d="M12.002,7.163c-2.673,0-4.838,2.168-4.838,4.836c0,2.672,2.165,4.838,4.838,4.838c2.669,0,4.836-2.166,4.834-4.838
                        C16.836,9.331,14.671,7.163,12.002,7.163z"/>
                                </SvgIcon>
                            </IconButton>
                        }
                        {process.env.BUILD_MODULE === "agyle" && <AgyleMenuIcon/>}
                        <IconButton onClick={handleDrawerClick}>
                            {!open ? <ChevronRightIcon /> : <ChevronLeftIcon />}
                        </IconButton>
                    </div>

                    {open &&
                        <IconButton
                            onClick={()=>openComponent(DashboardItem)}
                            sx={{
                                minWidth: 0,
                                mr: open ? 3 : 'auto',
                                justifyContent: 'center',
                                backgroundColor: DashboardItem.label === selectedItem.label ? "#E4EFFF" : "unset",
                                color: "#448FFF"
                            }}
                        >
                            {DashboardItem.icon}
                        </IconButton>
                    }
                </DrawerHeader>
                <Divider />
                {open && <div className={classes.menuText}>{t('MENU')}</div>}
                <List>
                    {!open &&
                        <ListItem disablePadding sx={{ display: 'block' }}>
                            <ListItemButton  onClick={()=>openComponent(DashboardItem)}
                                             sx={{
                                                 minHeight: 48,
                                                 justifyContent: open ? 'initial' : 'center',
                                                 px: 2.5,
                                                 backgroundColor: DashboardItem.label === selectedItem.label ? "#E4EFFF" : "unset",
                                                 color: "#448FFF"
                                             }}>
                                <ListItemIcon
                                    sx={{
                                        minWidth: 0,
                                        mr: open ? 3 : 'auto',
                                        justifyContent: 'center',
                                        color: "#448FFF"
                                    }}
                                >
                                    {DashboardItem.icon}
                                </ListItemIcon>
                            </ListItemButton>
                        </ListItem>
                    }
                    {getMenuItem().map((item, index) => (
                        <ListItem key={item.label} disablePadding sx={{ display: 'block' }}>
                            <ListItemButton  onClick={()=>openComponent(item)}
                                sx={{
                                    minHeight: 48,
                                    justifyContent: open ? 'initial' : 'center',
                                    px: 2.5,
                                    backgroundColor: item.label === selectedItem.label? "#E4EFFF": "unset"
                                }}
                            >
                                <ListItemIcon
                                    sx={{
                                        minWidth: 0,
                                        mr: open ? 3 : 'auto',
                                        justifyContent: 'center',
                                        color: item.label === selectedPatentItemLabel? "#448FFF": 'unset'
                                    }}
                                >
                                    {item.icon}
                                </ListItemIcon>
                                <Typography variant="subtitle2" sx={{
                                    display: open ? "block" : 'none',
                                    fontWeight: 900,
                                    color: item.label ===selectedPatentItemLabel ? "#448FFF": "unset"
                                }}>
                                    {item.label}
                                </Typography>
                                {open && item.subMenu && (expandSubMenu[index] ? <ExpandLess onClick={(e)=>handleSubMenuClick(e,index)}/> : <ExpandMore  onClick={(e)=>handleSubMenuClick(e,index)}/>)}
                            </ListItemButton>
                            {open && item.subMenu && <Collapse in={expandSubMenu[index]} timeout="auto" unmountOnExit>
                                <List component="div" disablePadding>
                                    {item.subMenu.map((subItem)=> {
                                        return (
                                            <ListItemButton onClick={() => openComponent(subItem, item.label)}
                                                            key={subItem.label} sx={{
                                                pl: 6,
                                                backgroundColor: subItem.name === selectedItem.name ? "#E4EFFF" : "unset",
                                            }}>
                                                <Typography variant="subtitle2" sx={{
                                                    display: open ? "block" : "none",
                                                    fontWeight: 900,
                                                    color: subItem.name === selectedItem.name ? "#448FFF" : "unset",
                                                }}
                                                >
                                                    {subItem.label}
                                                </Typography>
                                            </ListItemButton>
                                        );
                                    })}

                                </List>
                            </Collapse> }
                        </ListItem>
                    ))}
                </List>
            </Drawer>
            {/*<Box component="main" sx={{ flexGrow: 1, p: 1 }}>*/}
                <div style={{width: selectedItem.minContent? "unset": "100%", overflow: "auto"}}>
                    { selectedItem && renderComponent }
                </div>
            {/*</Box>*/}
        </Box>
    );
}